import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Axios from 'axios';
import isEmpty from 'lodash/isEmpty';

class Linkuploader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      url: '',
      status: '',
      result: {},
      uploaded: false,
    };

    this.onSetFileUrl = this.onSetFileUrl.bind(this);
    this.onImportLink = this.onImportLink.bind(this);
    this.removeImportedFile = this.removeImportedFile.bind(this);
  }

  onSetFileUrl(e) {
    console.log('onSetFileUrl', e.target.value || '');
    this.setState({
      url: e.target.value || '',
    });
  }

  onImportLink() {
    const regex = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gm;
    if (!regex.test(this.state.url)) {
      return this.setState({
        uploaded: false,
        status: ['Invalid url, please try again', 'error'],
      });
    }

    this.props.onimportstart(this.state.url);
    this.setState({
      uploaded: false,
      status: ['File import in progress, this may take a while...', 'loader'],
    }, () => {
      const { server, metadataObject } = this.props;
      Axios.post(server, {
        fileUrls: [this.state.url],
        ...metadataObject,
      })
        .then(res => {
          console.log(res);
          this.setState({
            uploaded: true,
            result: res.data,
            status: ['File has been succesfully imported', 'success'],
          }, () => {
            this.props.onimportcomplete(this.state.result)
          });
        })
        .catch(err => {
          console.log('ERROR upload', err.response);
          const { error = false, message = '' } = err.response && err.response.data || {};
          const smessage = (error) ? ` with message (${message})` : '';
          this.setState({
            uploaded: false,
            status: [`File import error${smessage}, please try again`, 'error'],
          }, () => {
            this.props.onimporterror(err);
          });
        });
    });
  }

  removeImportedFile() {
    if (isEmpty(this.state.result)) {
      return this.setState({
        status: 'Nothing to remove, please try again',
      });
    }

    this.setState({
      status: ['Removing imported file, please wait...', 'loader'],
    }, () => {
      const { server, serverRemove } = this.props;
      if (!serverRemove) {
        return this.successRemoval();
      }

      Axios.delete(server, {
        params: {
          url: this.state.result.url,
        },
      })
        .then(res => {
          console.log(res);
          this.successRemoval();
        })
        .catch(err => {
          console.log('ERROR upload', err);
          this.setState({
            status: ['Remove of imported file error, please try again', 'error'],
          });
        });
    });
  }

  successRemoval() {
    this.setState({
      uploaded: false,
      status: ['Removing of imported file completed', 'success'],
      result: {},
      url: ''
    }, () => {
      this.props.onimportremove();
      setTimeout(() => {
        this.setState({
          status: ''
        })
      }, 3000);
    });
  }

  renderRemove() {
    return (
      <span style={styles.removeBtn} onClick={this.removeImportedFile}>
        Remove
      </span>
    );
  }

  renderStatus(status) {
    const [ message, icon ] = status;
    const ext = (icon === 'loader') ? 'gif' : 'png';
    return (
      <React.Fragment>
        {!isEmpty(icon) && <img src={`../../images/status_${icon}.${ext}`} alt={icon} style={{marginRight: 5}}/>}
        {message}
      </React.Fragment>
    );
  }

  render() {
    const { status, uploaded } = this.state;
    return (
      <div style={styles.importFieldWrapper}>
        <div style={{ width: '100%', textAlign: 'left' }}>
          <input
            style={styles.importFieldtext}
            type="text"
            placeholder="Enter file URL. Link must be unprotected"
            onChange={this.onSetFileUrl}
            value={this.state.url}
          />
          <div style={styles.statusProcess}>
            {!isEmpty(status) && this.renderStatus(status)}
            {uploaded && this.renderRemove()}
          </div>
        </div>
        <button style={styles.importFieldBtn} onClick={this.onImportLink}>
          Import
        </button>
      </div>
    );
  }
}

const styles = {
  importFieldWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  importFieldtext: {
    margin: 0,
    fontSize: '1.5rem',
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5,
  },
  importFieldBtn: {
    backgroundColor: '#f76a1c',
    border: '1px solid #f76a1c',
    fontSize: '1.5rem',
    color: '#fff',
    padding: '0 20px',
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
    height: 40,
  },
  removeBtn: {
    color: '#e52828',
    fontWeight: 600,
    cursor: 'pointer',
    marginLeft: 10
  },
  statusProcess: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontSize: '1.4rem',
    padding: '5px 0'
  },
};

Linkuploader.propTypes = {
  server: PropTypes.string,
  serverRemove: PropTypes.bool,
  metadataObject: PropTypes.object,
  onimportstart: PropTypes.func,
  onimportcomplete: PropTypes.func,
  onimportcancel: PropTypes.func,
  onimportremove: PropTypes.func,
};

Linkuploader.defaultProps = {
  server: '/api/uploadv2',
  serverRemove: true,
  metadataObject: {},
  onimportstart: () => {},
  onimportcomplete: () => {},
  onimportcancel: () => {},
  onimportremove: () => {},
};

export default Linkuploader;
